import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from '../components/admin/AdminLayout';
import LoadingSpinner from '../components/ui/LoadingSpinner';

// Lazy imports
import {
  Index,
  Auth,
  Evaluation,
  Resultats,
  Offres,
  APropos,
  MaPrevention,
  NotFound,
  AdminDashboardPro,
  AdminDocuments
} from './lazyPages';

// Import direct pour les nouvelles pages
import MiniQuestionnaire from '../pages/MiniQuestionnaire';
import MiniResultats from '../pages/MiniResultats';
import AccesBilanComplet from '../pages/AccesBilanComplet';

// Composant de loading
const PageLoader = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingSpinner />}>
    {children}
  </Suspense>
);

export const AppRouter = () => {
  return (
    <Routes>
      {/* Routes publiques */}
      <Route path="/" element={<PageLoader><Index /></PageLoader>} />
      <Route path="/auth" element={<PageLoader><Auth /></PageLoader>} />
      <Route path="/mini-questionnaire" element={<MiniQuestionnaire />} />
      <Route path="/mini-resultats" element={<MiniResultats />} />
      <Route path="/acces-bilan-complet" element={<AccesBilanComplet />} />
      <Route path="/evaluation" element={<PageLoader><Evaluation /></PageLoader>} />
      <Route path="/resultats" element={<PageLoader><Resultats /></PageLoader>} />
      <Route path="/ma-prevention" element={<PageLoader><MaPrevention /></PageLoader>} />
      <Route path="/offres" element={<PageLoader><Offres /></PageLoader>} />
      <Route path="/a-propos" element={<PageLoader><APropos /></PageLoader>} />
      
      {/* Redirection admin */}
      <Route path="/admin" element={<Navigate to="/secure-admin-feel-2024" replace />} />
      
      {/* Routes Admin avec Layout et protection intégrée */}
      <Route path="/secure-admin-feel-2024/*" element={<AdminLayout />}>
        <Route index element={<PageLoader><AdminDashboardPro /></PageLoader>} />
        <Route path="documents" element={<PageLoader><AdminDocuments /></PageLoader>} />
      </Route>
      
      {/* 404 */}
      <Route path="*" element={<PageLoader><NotFound /></PageLoader>} />
    </Routes>
  );
};
